module.exports = __webpack_public_path__ + "img/fz-5.e1d92dd5.png";